import type { ReportConversionFunction } from '../types';

/**
 * Fires conversion pixel for Jobble referrals.
 */
export const reportJobbleConversion: ReportConversionFunction = () => {
  const ifrm = window.document.createElement('iframe');
  ifrm.setAttribute('src', 'https://www.googletagmanager.com/ns.html?id=GTM-ML36D6K');
  ifrm.style.width = '1px';
  ifrm.style.height = '1px';
  ifrm.frameBorder = '0';
  window.document.body.appendChild(ifrm);
};
